export const SITE_URL = 'https://www.centersoftech.com';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;

export const absoluteUrl = (path = '/') => `${SITE_URL}${path === '/' ? '' : path}`;
